import { render, staticRenderFns } from "./officialLive2d.vue?vue&type=template&id=541c309e&scoped=true"
import script from "./officialLive2d.vue?vue&type=script&lang=js"
export * from "./officialLive2d.vue?vue&type=script&lang=js"
import style0 from "./officialLive2d.vue?vue&type=style&index=0&id=541c309e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541c309e",
  null
  
)

export default component.exports